import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useEffect } from 'react';
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";

const InstituteLogin = () => {
    const [userUniqueId, setUserUniqueId] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');
    const [openErrorSnackbar] = useCustomSnackbar('error')
    const [openSuccessSnackbar] = useCustomSnackbar('success')
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const [emailError, setEmailError] = useState('');
    const [userNameError, setUserNameError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    useEffect(() => {
        if (email !== '') {
            setEmailError('')
        }
        if (userUniqueId !== '') {
            setUserNameError('')
        }
        if (password !== '') {
            setPasswordError('')
        }
    }, [email, userUniqueId, password]);

    const login = () => {
        const baseURL = process.env.REACT_APP_BACKEND_INSTITUTE_URL;
        const apiUrl = `${baseURL}/login`;

        if (email !== '' && userUniqueId !== '' && password !== '') {
            axios.post(apiUrl, {
                userUniqueId,
                email,
                password
            })
                .then(response => {
                    console.log('Data:', response.data);
                    localStorage.setItem('accessToken', response.data.token);
                    localStorage.setItem('userType', response.data.userType);
                    localStorage.setItem('instituteMasterId', response.data.instituteMasterId);
                    localStorage.setItem('instituteName', response.data?.instituteDetails?.instituteName);
                    localStorage.setItem('logoPath', response.data?.instituteDetails?.logoPath);
                    localStorage.setItem('instituteId', response.data?.instituteDetails?.instituteId);

                    // openSuccessSnackbar('Log in Successful.')
                    console.log("message : ", response);
                    Swal.fire(
                        { text: response.data.message }
                    );
                    navigate("/institute-dashboard");
                })
                .catch(error => {
                    // Handle any errors that occurred during the request
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                    console.error('Error fetching data:', error);
                });
        } else {
            if (email == '') {
                setEmailError('This field is required.')
            }
            if (userUniqueId == '') {
                setUserNameError('This field is required.')
            }
            if (password == '') {
                setPasswordError('This field is required.')
            }
        }
    }

    const forgetPassword = () => {
        navigate('/foget-password', { state: { userType: 'I' } });
    };

    const toggleVisibility = () => {
        setVisible(prevState => !prevState);
    };

    return (
        <div className="bg-light min-vh-100 d-flex flex-row align-items-center login-content">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="card-group d-block d-md-flex row login-box">
                            <div className="card col-md-7 p-4 mb-0">
                                <div className="card-body">
                                    {/* <h1>Login</h1>
                                    <p className="text-medium-emphasis">Sign In to your account</p> */}
                                    <div className='login-logo'>
                                        <img src={VidyaUpasna} />
                                    </div>
                                    <div className="input-group mb-3"><span className="input-group-text">
                                        <i class="fa-solid fa-envelope"></i>
                                        <svg className="icon">
                                            {/* <use xlink:href="node_modules/@coreui/icons/sprites/free.svg#cil-user"></use> */}
                                        </svg></span>
                                        <input className="form-control" type="email" placeholder="Email-Id" value={email} onChange={(e) => setEmail(e.target.value)} />

                                        {emailError && <br /> && <p className='errorClass' style={{ color: 'red' }}>{emailError}</p>}
                                    </div>
                                    <div className="input-group mb-3"><span className="input-group-text">
                                        <i class="fa-solid fa-user"></i>
                                        <svg className="icon">
                                            {/* <use xlink:href="node_modules/@coreui/icons/sprites/free.svg#cil-user"></use> */}
                                        </svg></span>
                                        <input className="form-control" type="text" placeholder="Username" value={userUniqueId} onChange={(e) => setUserUniqueId(e.target.value)} />

                                        {userNameError && <p className='errorClass' style={{ color: 'red' }}>{userNameError}</p>}
                                    </div>
                                    <div className="input-group mb-4 password"><span className="input-group-text">
                                        <i class="fa-solid fa-lock"></i>
                                        <svg className="icon">
                                            {/* <use xlink:href="node_modules/@coreui/icons/sprites/free.svg#cil-lock-locked"></use> */}
                                        </svg></span>
                                        <input className="form-control" type={visible ? "text" : "password"} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                        <button className='password_show_hide'>
                                            {visible ? (
                                                <i className="fa fa-eye" aria-hidden="true" onClick={toggleVisibility}></i>
                                            ) : (
                                                <i className="fa fa-eye-slash" onClick={toggleVisibility}></i>
                                            )}
                                        </button>

                                        {passwordError && <br /> && <p className='errorClass' style={{ color: 'red' }}>{passwordError}</p>}
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <button className="btn btn-primary px-4" type="button" onClick={login}>Login</button>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button className="btn btn-link px-0" type="button" onClick={forgetPassword}>Forgotten Password?</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="card col-md-5 text-white bg-primary py-5">
                <div className="card-body text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <button className="btn btn-lg btn-outline-light mt-3" type="button">Register Now!</button>
                  </div>
                </div>
              </div> */}
                        </div>
                    </div>
                </div>
                <div className='login-bottom-text'><h6> Powerd by</h6><img src="https://api.examninja.co.in/images/1705820792167-939.jpeg" /></div>

            </div>
        </div>
    )
};

export default InstituteLogin;